import * as Sentry from "@sentry/react";

// Initialize Sentry (GlitchTip) SDK
Sentry.init({
  // debug: true, // Enable for additional debugging information
  dsn: import.meta.env.VITE_GLITCHTIP_DSN,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.browserProfilingIntegration(),
    Sentry.replayIntegration(),
  ],
  // Capture 100% of transactions for performance monitoring
  tracesSampleRate: 1.0,
  // Define which URLs should have trace propagation
  tracePropagationTargets: [/^\//, /^https:\/\/yourserver\.io\/api/],
  // Record 10% of all sessions, and 100% of sessions with errors
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});